<template>
  <div class="main">
    <div class="nav">
      <Nav title="详情" :fixed="true"></Nav>
      <div class="top"></div>
    </div>
    <div class="body">
      <div class="title">
        <div class="tetle_text">
          {{ item.title }}
        </div>
      </div>
      <div class="Subtitle" v-if="item.create_time">
        <!-- 发布时间：{{ item.create_time.substr(0, 10) }} -->
      </div>
      <div class="content">
        <div v-html="content" class="p_text" ></div>
      </div>
      <!-- <div class="ql-snow">
        <div class="ql-snow" v-html="content"></div>
      </div> -->
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav.vue";
import doccard from "./components/doccard";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from 'vue-quill-editor';
export default {
  data() {
    return {
      item: {},
      content: null,
    };
  },
  components: {
    Nav,
    doccard,
  },
  mounted() {
    this.getinfo();
  },
  methods: {
    getinfo() {
      if (this.$route.query) {
        this.item = this.$route.query.item;
      }
      this.content = this.item.content;
    },
    showHtml(str) {
      console.log(str);
      return str
        .replace(str ? /&(?!#?\w+;)/g : /&/g, "&amp;")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&amp;nbsp;/g, "\u3000");
    },
  },
};
</script>

<style>


.main {
  padding: 0px;
  margin: 0px;
  background-color: #f7f8fa;
  width: 100%;
  height: 100%;
}
 .top {
      height: 50px;
      width: 1px;
    }
.Subtitle {
  text-align: right;
  line-height: 30px;
  font-size: 14px;
  color: #999;
}
.content {
  width: 100%;
  max-height: 80vh;
  word-wrap: break-word;
  border-top: #95a5a6 1px solid;
  font-size: 16px;
  color: #333;
  letter-spacing:1px;
 /* text-indent: 2em; */
  
}
/* .content img{
  margin-left: -2em;
}  */
.body {
  display: flex;
  flex-direction: column;
  width: 95%;
  margin: 0px auto;
  max-height: 100vh;
  overflow: scroll;
}
.p_text {
  width: 90%;
  margin: 0px auto;
  white-space: pre-wrap
        
}
.title {
  line-height: 35px;
}
.tetle_text {
  font-size: 18px;
  text-align: center;
  color: #333;
}
.img {
  width: 100;
}
.test_img {
  max-width: 100%;
  margin: 0px auto;
}

.p_text img {
  max-width: 100%;
}
</style>